import client, { deserializer } from 'services/client'
import { toSnake, toCamel } from 'change-object-case'

async function getTearsheetCustomTemplates() {
  const response = await client().get(`v2/tearsheets/custom_templates`)
  return toCamel(deserializer.deserialize(response), { recursive: true })
}

async function createTearsheetCustomTemplate(params) {
  const response = await client().post(
    'v2/tearsheets/custom_templates',
    toSnake(params, { recursive: true }),
  )
  return deserializer.deserialize(response)
}

async function updateTearsheetCustomTemplate(params) {
  const { id, ...rest } = params
  const response = await client().put(
    `v2/tearsheets/custom_templates/${id}`,
    toSnake(rest, { recursive: true }),
  )
  return deserializer.deserialize(response)
}

async function deleteTearsheetCustomTemplate(id) {
  return client().delete(`v2/tearsheets/custom_templates/${id}`)
}

export {
  getTearsheetCustomTemplates,
  createTearsheetCustomTemplate,
  updateTearsheetCustomTemplate,
  deleteTearsheetCustomTemplate,
}
